export const AUTONE_LANGUAGE_STORAGE_KEY = 'autone-lng';
